<p-dialog
  [visible]="!!pending()"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '30rem' }"
  styleClass="prd-confirm"
>
  <ng-template #header>
    <div class="prd-confirm__header">
      <i class="pi pi-exclamation-triangle"></i>
      <span>Production change</span>
    </div>
  </ng-template>

  @if (pending(); as req) {
    <div class="prd-confirm__body">
      <p class="prd-confirm__summary">{{ req.summary }}</p>
      @if (req.detail) {
        <p class="prd-confirm__detail">{{ req.detail }}</p>
      }
      <p class="prd-confirm__instruction">
        This affects <strong>PRODUCTION</strong>. Type <code>prd</code> to confirm.
      </p>
      <input
        pInputText
        class="prd-confirm__input"
        [value]="typed()"
        (input)="onTyped($any($event.target).value)"
        (keyup.enter)="confirm()"
        placeholder="prd"
        autocomplete="off"
        autofocus
      />
    </div>
  }

  <ng-template #footer>
    <p-button label="Cancel" severity="secondary" [text]="true" (onClick)="cancel()" />
    <p-button
      label="Confirm production change"
      severity="danger"
      [disabled]="!canConfirm()"
      (onClick)="confirm()"
    />
  </ng-template>
</p-dialog>
